<!--
 * @Description: 素材库/上传素材
 * @Author: hasayake
 * @Date: 2020-06-16 15:20:07
 * @LastEditTime: 2020-07-06 16:02:00
 * @LastEditors: Please set LastEditors
-->

<template>
  <el-dialog
    title="上传素材"
    :visible.sync="value"
    width="512px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="upload-material">
      <div class="upload-area">
        <el-select size="small" v-model="modeVal">
          <el-option
            v-for="item in modeList" :key="item.label"
            :value="item.value" :label="item.label" />
          </el-select>
        <div style="marginTop: 10px;" v-show="modeVal === 1">
          <el-button
            type="primary" size="small"
            class="input-upload">
            批量上传文件
            <input type="file" multiple @change="fileChangeHandler" />
          </el-button>
          <span class="upload-suffix"
            >支持扩展名：.rar .zip .doc .docx .pdf .jpg</span
          >
        </div>

      </div>
      <div class="upload-list" v-if="modeVal === 1">
        <h3>上传列表：</h3>
        <div class="upload-list-main">
          <div
            class="upload-list-item__wrapper"
            v-for="(item, idx) in uploadEdList"
            :key="idx"
          >
            <div class="upload-list-item">
              <img width="26" src="@/assets/images/file-icon.png" alt="" />
              <div class="upload-list-item-details">
                <div class="upload-list-item-name-size">
                  <div class="item-name">{{ item.name }}</div>
                  <span class="item-size"
                    >{{ (item.size / 1024).toFixed(2) }} KB
                  </span>
                </div>
                <i class="el-icon-success" style="color: #36C626;"></i>
              </div>
            </div>
            <el-progress :percentage="100"></el-progress>
          </div>
        </div>
      </div>

      <upload-url-main :projectId="projectId" v-else-if="modeVal === 0" @refresh="refresh" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
      <!-- <el-button type="primary" @click="handleClose">确 定</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import { uploadFileToOSS, materialLibrarysHandler } from "@/assets/js/api";
import { UPLOAD_ALLOW_SUFFIX_LIST } from "@/assets/js/config";
import uploadUrlMain from './uploadUrlMain'

export default {
  name: "uploadMaterial",

  props: {
    value: {
      type: Boolean,
      default: false
    },

    filePaths: {
      type: Array,
      default: () => []
    },

    curDirId: {
      type: String,
      default: ""
    },

    projectId: {
      type: String,
      default: ""
    }
  },

  components: {
    uploadUrlMain
  },

  data() {
    return {
      fileList: [],
      uploadEdList: [],
      ossConfigs: {},
      modeList: [
        { label: '上传URL', value: 0 },
        { label: '上传文件', value: 1 }
      ],
      modeVal: null
    };
  },

  methods: {
    handleClose() {
      if (this.uploadEdList.length > 0) {
        this.$emit("refresh");
        this.uploadEdList = [];
      }
      this.$emit("input", false);
    },
    refresh(){
      this.$emit("refresh");
    },
    fileChangeHandler(ev) {
      gtag('event', 'file', {
        'event_category' : 'upload',
        'event_label' : 'upload_file'
      });
      const e = ev || window.event;

      this.fileCheckHandler(Array.from(e.target.files));
      this.fileMultipleToOss();
    },
    // 文件选择上传
    async fileCheckHandler(fileArr) {
      this.fileList = [];
      for (const file of fileArr) {
        // 判断文件名是否含有敏感字符
        if (/(#|%|\+)+/g.test(file.name)) {
          // this.$message.warning("文件名不能含有特殊符号，如 #，%，+ 等。");
          continue;
        }
        const suffix = file.name
          .split(".")
          .slice(-1)[0]
          .toLowerCase();

        if (!UPLOAD_ALLOW_SUFFIX_LIST.includes(`.${suffix}`)) {
          continue;
        }

        this.fileList.push(file);
      }
    },
    // 文件批量请求
    async fileMultipleToOss() {
      let filePaths = this.filePaths.map(item => item.id).join("/") + "/";

      for (const file of this.fileList) {
        await uploadFileToOSS(
          this.ossConfigs,
          file,
          filePaths,
          file.name.replace(/(_|\/)/g, ""),
          () => {}
        );

        this.uploadEdList.push(file);
      }

      // 批量请求
      for (const file of this.uploadEdList) {
        this.ossFilePathToEndHandler({
          name: file.name.replace(/(_|\/)/g, ""),
          path: filePaths
        });
      }
    },

    // 获取 oss 配置
    getOssConfigs() {
      materialLibrarysHandler
        .getOssConfig()
        .then(res => {
          this.ossConfigs = res.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },

    // 将 oss 文件路径发送给后台
    ossFilePathToEndHandler({ name, path }) {
      const filePath = `http://${this.ossConfigs.bucketName +
        "." +
        this.ossConfigs.endpoint}/${path + name}`;

      materialLibrarysHandler
        .upload({
          parentId: +this.curDirId,
          urls: [filePath],
          projectId: this.projectId
        })
        .then(res => {
          this.$message.success(res.msg);
          this.getDirHandler(this.curDirId);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    }
  },

  created() {
    this.getOssConfigs();
  }
};
</script>

<style lang="scss">
.upload-material {
  position: relative;
  .upload-suffix {
    margin-left: 20px;
    font-size: 12px;
    color: #999;
  }

  // .input-upload {
  //   position: relative;

  //   input {
  //     position: absolute;
  //     width: 100%;
  //     height: 100%;
  //     min-width: 0;
  //     left: 0;
  //     top: 0;
  //     opacity: 0;
  //     font-size: 0;
  //     cursor: pointer;
  //   }
  // }

  .upload-list-item__wrapper {
    margin-bottom: 20px;
  }

  .upload-list-main {
    height: 320px;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    overflow-y: auto;
  }

  .upload-list-item {
    display: flex;
  }

  .upload-list-item-details {
    display: flex;
    margin-left: 20px;
    justify-content: space-between;
    flex: 1;

    i {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .upload-list-item-name-size {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 12px;

    .item-name {
      color: #606266;
    }

    .item-size {
      color: #909399;
    }
  }

  .el-progress-bar {
    padding-right: 0;
  }

  .el-progress__text {
    display: none;
  }
}
</style>
